"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrLike = void 0;
/** A class compatible with { message: string } that can be mutated by iterating functions */
class ErrLike {
    constructor(message) {
        this.messages = [];
        if (message)
            this.messages.push(message);
    }
    /** gets/adds to the concatenated string of messages */
    get message() {
        return this.messages.join(', ');
    }
    /** adds msg provided it is a string */
    set message(msg) {
        if (typeof msg === 'string') {
            this.messages.push(msg);
        }
    }
    isPopulated() {
        return this.messages.length > 0;
    }
    toString() {
        return this.message;
    }
}
exports.ErrLike = ErrLike;
